import * as _ from 'lodash';
import * as qs from 'query-string';
import { Component, FormEvent } from 'react';
import { Dispatch, connect } from 'react-redux';
import { IApplicationState, AppActionCreators, IAppState, GpsActionCreators, IGpsItemsResponse, IGpsItemsCentralRecordsResponse, IGpsCountsResponse, IGpsDeviceListResponse, IGpsLookupDataResponse } from '@nkr/store/index';
import { gpsListTypeMap, IBaseResponse, IGPSCounts, IGpsDevice, IGpsItemsForList, IGpsStatusRequest, IGpsItemsForCentralRecords, IListItem, ICenterBase } from '@nkr/models/index';
import { GpsListType } from '@nkr/enums/index';
import { GpsAction } from './gps-action';
import { GpsTrackingNumberType } from './gps-tracking-number-type';
import { ColDef, CsvExportParams, GridApi, GridReadyEvent, ProcessCellForExportParams } from 'ag-grid-community';
import { toast } from 'react-toastify';
import { Button, FormControl, Well } from 'react-bootstrap';
import { downloadFile } from '@nkr/services/download-file';
import { GridWrapper } from './styles';
import GpsCentralGrid from './gps-central-grid';
import Grid from './grid';
import * as moment from 'moment';
import GPSNav from './nav';
import ShipGps from './modals/ship-gps';
import AddTrackingNumber from './modals/add-tracking-number';
import ReturnedConfirmation from './modals/returned-confirmation';
import AddTrackingComments from './modals/add-tracking-comments';
import { numberFormat } from 'highcharts';

interface IProps {
    centerId: number,
    activeKey: string,
    itemId?: number,
}

interface IStateProps {
    app: IAppState
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    getGpsCounts: () => Promise<IGpsCountsResponse>,
    getGpsLookupData: () => Promise<IGpsLookupDataResponse>,
    getGpsList: (listType: GpsListType, gspNumber: string, chainId: string) => Promise<IGpsItemsResponse>,
    getGpsCentralRecords: (startDate: string, endDate: string, category: number, catSearch: string, center: number) => Promise<IGpsItemsCentralRecordsResponse>,
    getGpsExport: (reportType: GpsListType) => Promise<any>
    markGpsStatus: (gpsStatusRequest: IGpsStatusRequest) => Promise<IBaseResponse>,
    bulkGpsPrint: (list: number[], batchType: number) => Promise<any>,
    getGpsDeviceList: () => Promise<IGpsDeviceListResponse>
}

type TProps = IProps & IStateProps & IDispatchProps;

interface IState {
    // [index: string]:
    // | string
    // | IGPSCounts
    // | GpsListType
    // | boolean
    // | IGpsItemsForList[]
    // | IGpsItemsForCentralRecords[]
    // | IGpsDevice[]
    // | IListItem[]
    // | ICenterBase[]
    // | { show: boolean; gpsAction: GpsAction; data: IGpsItemsForList }
    // | { show: boolean; trackingType: GpsTrackingNumberType; data: IGpsItemsForList }
    // | { show: boolean; data: IGpsItemsForList }
    // | { show: boolean; data: IGpsItemsForCentralRecords };
    counts: IGPSCounts,
    list: IGpsItemsForList[],
    gpsCentralRecords: IGpsItemsForCentralRecords[],
    listType: GpsListType,
    gpsNumber: string,
    chainId: string,
    startDate: string,
    endDate: string,
    category: number,
    catSearch: string,
    centerList: ICenterBase[],
    center: number,
    categoryList: IListItem[],
    gpsDeviceList: IGpsDevice[],
    confirmGpsInfo: {
        show: boolean,
        gpsAction: GpsAction,
        data: IGpsItemsForList
    },
    confirmTrackingInfo: {
        show: boolean,
        trackingType: GpsTrackingNumberType,
        data: IGpsItemsForList
    },
    confirmTrackingComment: {
        show: boolean,
        data: IGpsItemsForCentralRecords
    },
    confirmReturned: {
        show: boolean,
        data: IGpsItemsForList
    },
    selectAllRows: boolean,
    isLoading: boolean,
    gridApi: GridApi
}

class GpsList extends Component<TProps, IState> {
    readonly state: IState = {
        counts: {
            pendShip: 0, shippedToMC: 0, pendingGPS: 0, needsActivation: 0,
            inProcess: 0, returnToNKR: 0, pendNkrReceipt: 0
        },
        list: [],
        gpsCentralRecords: [],
        listType: null,
        gpsNumber: '',
        chainId: '',
        startDate: moment().subtract(30, 'days').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        category: 0,
        catSearch: '',
        gpsDeviceList: [],
        centerList: [],
        center: 0,
        categoryList: [],
        confirmGpsInfo: {
            show: false,
            gpsAction: null,
            data: null
        },
        confirmTrackingInfo: {
            show: false,
            trackingType: null,
            data: null
        },
        confirmTrackingComment: {
            show: false,
            data: null
        },
        confirmReturned: {
            show: false,
            data: null
        },
        selectAllRows: false,
        isLoading: true,
        gridApi: null
    }

    // gridApi: GridApi = null;

    onGridReady = (e: GridReadyEvent) => {
        e.api.sizeColumnsToFit();

        this.setState({
            gridApi: e.api
        });
    }

    componentDidMount = () => {
        let { startDate, endDate } = this.state
        this.getData(startDate, endDate);
    }

    getListType = () => {
        let item = gpsListTypeMap.find(x => x.url == this.props.activeKey.toLowerCase());

        if (item != null) {
            return item.type;
        }
        return GpsListType.PendingShip;
    }

    getData = (startDate: string, endDate: string) => {
        let listType = this.getListType();
        let parsed = qs.parse(location.search.length > 0 ? location.search : encodeURI(''));
        let gpsId = parsed.id != null ? parsed.id : 0;
        let { chainId, gpsNumber, category, catSearch, center } = this.state;

        this.props.showLoading('Getting list of gps, one moment please...').then(async () => {
            let countsResponse = await this.props.getGpsCounts();
            let response = await this.props.getGpsList(listType, gpsNumber, chainId);
            let gpsDeviceListResponse = await this.props.getGpsDeviceList();
            let centralResponse = await this.props.getGpsCentralRecords(startDate, endDate, category, catSearch, center);
            let gpsLookupResponse = await this.props.getGpsLookupData();

            if (countsResponse.data.success && response.data.success && gpsDeviceListResponse.data.success && centralResponse.data.success && gpsLookupResponse.data.success) {
                let list = response.data.results;
                let gpsCentralRecords = centralResponse.data.results;
                let isLoading = list.length == 0 ? false : true;
                let gpsLookupData = gpsLookupResponse.data.results;

                this.setState({
                    counts: countsResponse.data.results,
                    list,
                    gpsCentralRecords,
                    isLoading,
                    listType,
                    gpsDeviceList: gpsDeviceListResponse.data.results,
                    categoryList: gpsLookupData.categoryList,
                    centerList: gpsLookupData.centerList
                }, () => {
                    //refactor this
                    if (gpsId != 0) {
                        const map: Record<number, number> = {
                            [GpsListType.PendingShip]: GpsAction.AddGpsNumber,
                            [GpsListType.PendingGps]: GpsAction.MarkActive,
                            [GpsListType.ReturnToNKR]: GpsAction.MarkShippedBack
                        };

                        let action = GpsAction.AddGpsLink;

                        let foundInMap = map[listType];

                        if (foundInMap) {
                            action = foundInMap;
                        }

                        this.handleItemSelected(gpsId, action, null, '');
                    }
                });
            }

            this.props.hideLoading();
        });
    }

    setConversionUrl = (gpsAutomationId: number) => {
        let listType = this.getListType();
        let gpsUrl = '';

        switch (listType) {
            case GpsListType.PendingShip:
                gpsUrl = 'pend-gps-assign';
                break;
            case GpsListType.PendingGps:
                gpsUrl = 'pending-journey';
                break;
            case GpsListType.ReturnToNKR:
                gpsUrl = 'return-to-nkr';
                break;
            case GpsListType.InProcess:
                gpsUrl = 'in-process';
                break;
        }

        let params = gpsAutomationId != 0 ? encodeURI('/?id=' + gpsAutomationId) : '';
        let newUrl = '/admin/gps/' + gpsUrl + '' + params;

        window.history.pushState({}, '', newUrl);
    }

    handleItemSelected = (id: number, action: GpsAction, trackingType: GpsTrackingNumberType, comment: string) => {
        let data = this.state.list.find(x => x.id == id);

        let gpsStatusRequest: IGpsStatusRequest = {
            id: id,
            markStatus: action,
            trackingNumberType: trackingType,
            outboundTrackingNumber: '',
            returnTrackingNumber: '',
            gpsLink: '',
            gpsNumber: 0,
            gpsComments: comment
        }

        switch (action) {
            case GpsAction.AddGpsNumber:
            case GpsAction.MarkActive:
                this.setState({
                    confirmGpsInfo: {
                        show: true,
                        gpsAction: action,
                        data
                    }
                }, () => {
                    this.setConversionUrl(id)
                });

                break;

            case GpsAction.AddTrackingNumber:
                this.setState({
                    confirmTrackingInfo: {
                        show: true,
                        trackingType,
                        data
                    }
                });

                break;

            case GpsAction.MarkShippedBack:
                this.setState({
                    confirmReturned: {
                        show: true,
                        data
                    }
                }, () => {
                    this.setConversionUrl(id)
                });

                break;

            case GpsAction.MarkNeedsReturned:
                this.setConversionUrl(0)
                break;

            case GpsAction.ViewGpsCentral:
                var gpsLink = data.gpsLink;
                window.open(gpsLink, '_blank');
                break;

            case GpsAction.MarkNeedsReturned:
                this.props.showLoading('Updating gps record, one moment please...').then(() => {
                    this.props.markGpsStatus(gpsStatusRequest)
                        .then(response => {
                            if (response.data.success) {
                                toast.success('Successfully updated gps record');

                                this.getData('', '');
                            }
                        })
                        .finally(() => {
                            this.props.hideLoading();
                        });
                });

                break;

            case GpsAction.AddTrackingComment:
                let dataComments = this.state.gpsCentralRecords.find(x => x.id == id);

                this.setState({
                    confirmTrackingComment: {
                        show: true,
                        data: dataComments
                    }
                });
        }
    }

    handleAddTrackingFieldChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        let data = _.cloneDeep(this.state.confirmTrackingInfo.data);

        let value = e.currentTarget.value;

        if (this.state.confirmTrackingInfo.trackingType == GpsTrackingNumberType.OutboundTrackingNumber) {
            data.outboundTrackingNumber = value;
        }

        if (this.state.confirmTrackingInfo.trackingType == GpsTrackingNumberType.ReturnTrackingNumber) {
            data.returnTrackingNumber = value;
        }

        this.setState({
            confirmTrackingInfo: {
                ...this.state.confirmTrackingInfo,
                data
            }
        });
    };

    handleAddCommentsFieldChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        let data = _.cloneDeep(this.state.confirmTrackingComment.data);
        let value = e.currentTarget.value;

        data.gpsComments = value;

        this.setState({
            confirmTrackingComment: {
                ...this.state.confirmTrackingComment,
                data
            }
        });
    };

    handleFieldChange = (field: string, value: any) => {
        let data = _.cloneDeep(this.state.confirmGpsInfo.data);

        if (field == 'gpsNumber') {
            data.gpsNumber = parseInt(value);
        }

        if (field == 'gpsLink') {
            data.gpsLink = value;
        }

        this.setState({
            confirmGpsInfo: {
                ...this.state.confirmGpsInfo,
                data
            }
        });
    }

    handleInputChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        let { name, value } = e.currentTarget;

        if (name == 'startDate') {
            this.setState({
                startDate: value
            });
        }

        if (name == 'endDate') {
            this.setState({
                endDate: value
            });
        }

        if (name == 'category') {
            this.setState({
                category: parseInt(value)
            });
        }

        if (name == 'center') {
            this.setState({
                center: parseInt(value)
            });
        }

        if (name == 'catSearch') {
            this.setState({
                catSearch: value
            });
        }
    }

    handleSearch = () => {
        this.getData(this.state.startDate, this.state.endDate);
    }

    handleExport = () => {
        const allColumns = this.state.gridApi.getColumnDefs() as ColDef[];
        const columnKeys = allColumns.filter(col => (col.hide ?? false) == false && col.colId != 'rowNumber').map(col => col.colId);

        let params: CsvExportParams = {
            columnGroups: true,
            columnKeys: columnKeys,
            fileName: 'gps-central-records.csv',
            processCellCallback: (params: ProcessCellForExportParams) => {
                let colDef = params.column.getColDef();

                if (colDef.headerName == 'Rank') {
                    return params.node.rowIndex + 1;
                } else if (colDef.colId == 'xpDate') {
                    return moment(params.value).format('MM/DD/YYYY');
                }

                return params.value;
            }
        };

        this.state.gridApi.exportDataAsCsv(params);
    }

    handleMarkShipGps = () => {
        let gpsAction = this.state.confirmGpsInfo.gpsAction;
        let { gpsLink, gpsNumber, id } = this.state.confirmGpsInfo.data;
        let { startDate, endDate } = this.state;

        let gpsStatusRequest: IGpsStatusRequest = {
            id,
            markStatus: gpsAction,
            trackingNumberType: null,
            outboundTrackingNumber: '',
            returnTrackingNumber: '',
            gpsLink,
            gpsNumber,
            gpsComments: ''
        }

        this.setState({
            confirmGpsInfo: {
                show: false,
                gpsAction: null,
                data: null
            }
        }, () => {
            this.props.showLoading('Updating gps record, one moment please...').then(() => {
                this.props.markGpsStatus(gpsStatusRequest)
                    .then(response => {
                        if (response.data.success) {
                            toast.success('Successfully updated gps record');

                            this.setConversionUrl(0);
                            this.getData(startDate, endDate);
                        }
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        });
    }

    handleAddTrackingNumber = (trackingType: GpsTrackingNumberType) => {
        let { outboundTrackingNumber, returnTrackingNumber, id } = this.state.confirmTrackingInfo.data;
        let { startDate, endDate } = this.state;

        let gpsStatusRequest: IGpsStatusRequest = {
            id,
            markStatus: GpsAction.AddTrackingNumber,
            outboundTrackingNumber,
            returnTrackingNumber,
            trackingNumberType: trackingType,
            gpsLink: '',
            gpsNumber: 0,
            gpsComments: ''
        }

        this.setState({
            confirmTrackingInfo: {
                show: false,
                trackingType,
                data: null
            }
        }, () => {
            this.props.showLoading('Updating gps record, one moment please...').then(() => {
                this.props.markGpsStatus(gpsStatusRequest)
                    .then(response => {
                        if (response.data.success) {
                            toast.success('Successfully updated gps record');

                            this.setConversionUrl(0);
                            this.getData(startDate, endDate);

                        }
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        });
    }

    handleAddTrackingComment = () => {
        let { gpsComments, id } = this.state.confirmTrackingComment.data;
        let { startDate, endDate } = this.state;

        let gpsStatusRequest: IGpsStatusRequest = {
            id,
            markStatus: GpsAction.AddTrackingComment,
            outboundTrackingNumber: '',
            returnTrackingNumber: '',
            trackingNumberType: 0,
            gpsLink: '',
            gpsNumber: 0,
            gpsComments
        }

        this.setState({
            confirmTrackingComment: {
                show: false,
                data: null
            }
        }, () => {
            this.props.showLoading('Updating gps record, one moment please...').then(() => {
                this.props.markGpsStatus(gpsStatusRequest)
                    .then(response => {
                        if (response.data.success) {
                            toast.success('Successfully updated gps record');

                            this.setConversionUrl(0);
                            this.getData(startDate, endDate);

                        }
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        });
    }

    handleMarkReturned = () => {
        let { id } = this.state.confirmReturned.data;
        let { startDate, endDate } = this.state;

        let gpsStatusRequest: IGpsStatusRequest = {
            id,
            markStatus: GpsAction.MarkShippedBack,
            outboundTrackingNumber: '',
            returnTrackingNumber: '',
            trackingNumberType: null,
            gpsLink: '',
            gpsNumber: 0,
            gpsComments: ''
        }

        this.setState({
            confirmReturned: {
                show: false,
                data: null
            }
        }, () => {
            this.props.showLoading('Updating gps record, one moment please...').then(() => {
                this.props.markGpsStatus(gpsStatusRequest)
                    .then(response => {
                        if (response.data.success) {
                            toast.success('Successfully updated gps record');

                            this.setConversionUrl(0);
                            this.getData(startDate, endDate);
                        }
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        });
    }

    handleMarkLost = () => {
        let { id } = this.state.confirmReturned.data;
        let { startDate, endDate } = this.state;

        let gpsStatusRequest: IGpsStatusRequest = {
            id,
            markStatus: GpsAction.MarkedLost,
            outboundTrackingNumber: '',
            returnTrackingNumber: '',
            trackingNumberType: null,
            gpsLink: '',
            gpsNumber: 0,
            gpsComments: ''
        }

        this.setState({
            confirmReturned: {
                show: false,
                data: null
            }
        }, () => {
            this.props.showLoading('Updating gps record, one moment please...').then(() => {
                this.props.markGpsStatus(gpsStatusRequest)
                    .then(response => {
                        if (response.data.success) {
                            toast.success('Successfully updated gps record');

                            this.setConversionUrl(0);
                            this.getData(startDate, endDate);
                        }
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        });
    }

    handleCancelShipGps = () => {
        this.setState({
            confirmGpsInfo: {
                show: false,
                gpsAction: null,
                data: null
            }
        });
    }

    handleCancelTrackingNumber = () => {
        this.setState({
            confirmTrackingInfo: {
                show: false,
                trackingType: null,
                data: null
            }
        });
    }

    handleCancelTrackingComment = () => {
        this.setState({
            confirmTrackingComment: {
                show: false,
                data: null
            }
        });
    }

    handleCancelMarkReturned = () => {
        this.setState({
            confirmReturned: {
                show: false,
                data: null
            }
        });
    }

    handleSelectAllRows = () => {
        let gpsList = this.state.list.map(x => x.id);

        let list = _.cloneDeep(this.state.list).map(x => {
            if (gpsList.indexOf(x.id) >= 0) {
                x.isSelected = !this.state.selectAllRows;
            }

            return x;
        });

        this.setState({
            list,
            selectAllRows: !this.state.selectAllRows
        });
    }

    handleRowSelected = (gpsAutomationId: number, isSelected: boolean) => {
        let list = _.cloneDeep(this.state.list).map(x => {
            if (x.id == gpsAutomationId) {
                x.isSelected = isSelected;
            }

            return x;
        });

        this.setState({
            list
        });
    }

    handleBulkGpsPrint = (batchType: number) => {
        let gpsList = this.state.list.filter(item => item.isSelected == true).map(item => item.id);

        this.props.showLoading('Downloading bulk GPS print file, one moment please...').then(() => {
            this.props.bulkGpsPrint(gpsList, batchType)
                .then((response: any) => {
                    downloadFile(response.data, `bulk-gps-print-results.pdf`, 'application/pdf');
                })
                .catch(async (error) => {
                    if (error?.response?.data instanceof Blob) {
                        const text = await error.response.data.text();

                        try {
                            const json = JSON.parse(text);

                            toast.error(json.message || text, {
                                autoClose: false
                            });
                        }
                        catch {
                            toast.error(text, {
                                autoClose: false
                            });
                        }
                    } else {
                        const message =
                            error?.response?.data ||
                            error?.message ||
                            'Unexpected error';

                        toast.error(message, {
                            autoClose: false
                        });
                    }
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    handleFilterChange = (chainId: string, gpsNumber: string) => {
        this.setState({
            chainId,
            gpsNumber
        }, () => {
            if (chainId.length == 0 && gpsNumber.length == 0) {
                this.handleFilter();
            }
        });
    }

    handleFilter = () => {
        let listType = this.getListType();
        let { chainId, gpsNumber } = this.state;

        this.props.showLoading('Getting list of gps, one moment please...').then(async () => {
            let response = await this.props.getGpsList(listType, gpsNumber, chainId);

            if (response.data.success) {
                let list = response.data.results;
                let isLoading = list.length == 0 ? false : true;

                this.setState({
                    list,
                    isLoading,
                    listType
                }, () => {
                    this.props.hideLoading();
                });
            }
        }).catch(() => {
            alert('An error occured while loading report data');
            this.props.hideLoading();
        });
    }

    handleExportGps = (reportType: GpsListType) => {
        let fileName = '';

        this.props.showLoading('Exporting CSV file, one moment please...').then(() => {
            this.props.getGpsExport(reportType).then((response: any) => {
                switch (reportType) {
                    case GpsListType.PendingShip: fileName = 'pendingShip'; break;
                    case GpsListType.PendingGps: fileName = 'pendingGps'; break;
                    case GpsListType.InProcess: fileName = 'inProcess'; break;
                    case GpsListType.ReturnToNKR: fileName = 'returnToNKR'; break;
                }

                downloadFile(response.data, `gps-automation_` + fileName + `.csv`, 'text/csv');

                this.props.hideLoading();
            });
        });
    }

    render = () => {
        const allowBulk = this.state.list.filter(x => x.isSelected).length > 0;

        return (
            <>
                <GPSNav
                    counts={this.state.counts}
                    activeKey={this.props.activeKey}
                />

                {this.props.activeKey !== 'GPS-CENTRAL' && (
                    <>
                        <Well bsStyle='sm' style={{ paddingTop: 4.5, paddingBottom: 4.5, marginBottom: 5 }}>
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <div style={{ display: 'flex', alignItems: 'center', marginRight: 20 }}>
                                    <div style={{ marginRight: 10 }}>Pending GPS Assign&nbsp;<strong>{this.state.counts.pendShip}</strong></div>
                                    <Button bsStyle='success' bsSize='xs' onClick={() => this.handleExportGps(GpsListType.PendingShip)}>Export CSV</Button>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', marginRight: 20 }}>
                                    <div style={{ marginRight: 10 }}>Pending Journey:&nbsp;<strong>{this.state.counts.pendingGPS}</strong></div>
                                    <Button bsStyle='success' bsSize='xs' onClick={() => this.handleExportGps(GpsListType.PendingGps)}>Export CSV</Button>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', marginRight: 20 }}>
                                    <div style={{ marginRight: 10 }}>In Process:&nbsp;<strong>{this.state.counts.inProcess}</strong></div>
                                    <Button bsStyle='success' bsSize='xs' onClick={() => this.handleExportGps(GpsListType.InProcess)}>Export CSV</Button>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <div style={{ marginRight: 10 }}>Pending Return:&nbsp;<strong>{this.state.counts.returnToNKR}</strong></div>
                                    <Button bsStyle='success' bsSize='xs' onClick={() => this.handleExportGps(GpsListType.ReturnToNKR)}>Export CSV</Button>
                                </div>
                            </div>
                        </Well>

                        {this.state.listType !== null && (
                            <>
                                <div style={{ width: '100%' }}>
                                    <GridWrapper id='grid-wrapper' className='container-fluid-max-sm ag-theme-bootstrap'>
                                        <Grid
                                            centerId={this.props.centerId}
                                            listType={this.state.listType}
                                            list={this.state.list}
                                            isLoading={this.state.isLoading}
                                            onSelectAllRows={this.handleSelectAllRows}
                                            onRowSelected={this.handleRowSelected}
                                            onGridReady={this.onGridReady}
                                            onItemSelected={this.handleItemSelected}
                                            isAdmin={true}
                                            isAdminLogin={true}
                                        />
                                    </GridWrapper>

                                    <div>{this.state.list.length} gps(s) shown...</div>
                                </div>

                                <div className='row' style={{ marginTop: 0, marginBottom: 10, height: 5 }}></div>
                                <div className='row' style={{ marginTop: 0, marginBottom: 10, height: 5 }}></div>
                                <div className='row' style={{ marginLeft: 0, marginBottom: 10, height: 70 }}>
                                    <Button bsStyle='primary' disabled={allowBulk === false} onClick={() => this.handleBulkGpsPrint(0)}>
                                        Create OPS Batch File
                                    </Button>
                                    &nbsp;
                                    <Button bsStyle='primary' disabled={allowBulk === false} onClick={() => this.handleBulkGpsPrint(1)}>
                                        Create Center Batch File
                                    </Button>
                                </div>
                            </>
                        )}
                    </>
                )}

                {this.props.activeKey == 'GPS-CENTRAL' && (
                    <>
                        <Well bsStyle='sm' style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div style={{ display: 'flex' }}>
                                <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                                    <div style={{ marginRight: 5 }}>Start Date:&nbsp;</div>
                                    <div>
                                        <FormControl
                                            type='date'
                                            name='startDate'
                                            value={this.state.startDate}
                                            onChange={this.handleInputChange}
                                        />
                                    </div>
                                </div>

                                <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                                    <div style={{ marginRight: 5 }}>End Date:</div>
                                    <div>
                                        <FormControl
                                            type='date'
                                            name='endDate'
                                            value={this.state.endDate}
                                            onChange={this.handleInputChange}
                                        />
                                    </div>
                                </div>

                                <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                                    <div style={{ marginRight: 8, whiteSpace: 'nowrap' }}>Search By:</div>
                                    <FormControl
                                        componentClass='select'
                                        id='category'
                                        name='category'
                                        value={this.state.category}
                                        onChange={this.handleInputChange}
                                        style={{ minWidth: 200 }} // optional: set a width for better spacing
                                    >
                                        <option value={0}>- All Categories -</option>
                                        {this.state.categoryList.map((category) => (
                                            <option key={'cat-' + category.id} value={category.id}>
                                                {category.description}
                                            </option>
                                        ))}
                                    </FormControl>
                                </div>

                                {(this.state.category == 2 || this.state.category == 3) && (
                                    <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                                        <div style={{ marginRight: 5 }}>Center:</div>
                                        <FormControl
                                            componentClass='select'
                                            name='center'
                                            value={this.state.center}
                                            onChange={this.handleInputChange}
                                        >
                                            <option value={0}>- All Centers -</option>
                                            {this.state.centerList.map((center) => (
                                                <option key={'ctr-' + center.id} value={center.id}>
                                                    {center.alias}
                                                </option>
                                            ))}
                                        </FormControl>
                                    </div>
                                )}

                                {(this.state.category == 1 || this.state.category == 4) && (
                                    <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                                        <FormControl
                                            name='catSearch'
                                            value={this.state.catSearch}
                                            onChange={this.handleInputChange}
                                        />
                                    </div>
                                )}

                                <div>
                                    <Button bsStyle={'primary'} onClick={this.handleSearch}>Search</Button>
                                </div>
                            </div>

                            <div style={{ display: 'flex', alignItems: 'flex-end', fontSize: 13 }}>
                                <span style={{ backgroundColor: '#c9372e', color: 'white', padding: '2px 5px', borderRadius: 4, border: '1px solid #ddd' }}>
                                    Swap Cancelled
                                </span>&nbsp;
                                <span style={{ backgroundColor: 'yellow', padding: '2px 5px', borderRadius: 4, border: '1px solid #ddd' }}>
                                    OBC Plan
                                </span>&nbsp;
                            </div>

                            <div>
                                <Button bsStyle='success' onClick={this.handleExport}>Export CSV</Button>
                            </div>
                        </Well>

                        <div style={{ width: '100%' }}>
                            <GridWrapper id='grid-wrapper' className='container-fluid-max-sm ag-theme-bootstrap'>
                                <GpsCentralGrid
                                    gpsCentralRecords={this.state.gpsCentralRecords}
                                    listType={this.state.listType}
                                    centerId={this.props.centerId}
                                    isAdmin={true}
                                    isAdminLogin={true}
                                    isLoading={this.state.isLoading}
                                    onSelectAllRows={this.handleSelectAllRows}
                                    onRowSelected={this.handleRowSelected}
                                    onGridReady={this.onGridReady}
                                    onItemSelected={this.handleItemSelected}
                                />
                            </GridWrapper>
                            <div>{this.state.gpsCentralRecords.length} gps(s) shown...</div>
                        </div>
                    </>
                )}

                <ShipGps
                    gpsAction={this.state.confirmGpsInfo.gpsAction}
                    show={this.state.confirmGpsInfo.show}
                    data={this.state.confirmGpsInfo.data}
                    gpsList={this.state.gpsDeviceList}
                    onFieldChange={this.handleFieldChange}
                    onConfirm={this.handleMarkShipGps}
                    onCancel={this.handleCancelShipGps}
                />

                <AddTrackingNumber
                    show={this.state.confirmTrackingInfo.show}
                    data={this.state.confirmTrackingInfo.data}
                    trackingType={this.state.confirmTrackingInfo.trackingType}
                    onFieldChange={this.handleAddTrackingFieldChange}
                    onConfirm={this.handleAddTrackingNumber}
                    onCancel={this.handleCancelTrackingNumber}
                />

                <AddTrackingComments
                    show={this.state.confirmTrackingComment.show}
                    data={this.state.confirmTrackingComment.data}
                    onFieldChange={this.handleAddCommentsFieldChange}
                    onConfirm={this.handleAddTrackingComment}
                    onCancel={this.handleCancelTrackingComment}
                />

                <ReturnedConfirmation
                    show={this.state.confirmReturned.show}
                    data={this.state.confirmReturned.data}
                    onConfirm={this.handleMarkReturned}
                    onCancel={this.handleCancelMarkReturned}
                    onLost={this.handleMarkLost}
                />
            </>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app
    };
}

const mapDispatchToProps = (dispatch: Dispatch<any>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            return dispatch(AppActionCreators.hideLoading());
        },
        getGpsCounts: () => {
            return dispatch(GpsActionCreators.getGpsCounts());
        },
        getGpsList: (listType, gspNumber, chainId) => {
            return dispatch(GpsActionCreators.getGpsReportList(listType, gspNumber, chainId));
        },
        getGpsLookupData: () => {
            return dispatch(GpsActionCreators.getGpsLookupData());
        },
        getGpsCentralRecords: (startDate, endDate, category, catSearch, center) => {
            return dispatch(GpsActionCreators.getGpsCentralRecords(startDate, endDate, category, catSearch, center));
        },
        getGpsExport: (reportType) => {
            return dispatch(GpsActionCreators.getGpsExport(reportType, '', ''));
        },
        markGpsStatus: (gpsStatus) => {
            return dispatch(GpsActionCreators.markGpsStatus(gpsStatus));
        },
        bulkGpsPrint: (list, batchType) => {
            return dispatch(GpsActionCreators.bulkGpsPrint(list, batchType));
        },
        getGpsDeviceList: () => {
            return dispatch(GpsActionCreators.getGpsDeviceList());
        },
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(GpsList);